import {useEffect, useState} from 'react'
import {
  Box,
  LinkBox,
  Link,
  Text,
 
} from "@chakra-ui/react"

import { FaMinus } from "react-icons/fa6"; 

import { useDispatch,useSelector } from "react-redux";
import { getCategories } from "../../slices/pProperties";


export default function Categories(props) {
    const {handleFilterChange,filters,backendFilters}=props
    const [selectedCategory, setSelectedCategory] = useState(null)

    useEffect(() => {
        setSelectedCategory(filters.categories);
      }, [filters.categories]);

    const [listItems, setListItems] =useState([]);

    const sectionBg = "white"
    const headingColor = "gray.700"
    const dividerColor = "gray.200"
  

    useEffect(() => {
    
        if (backendFilters?.categories) {
    const flatCategories = Object.entries(backendFilters.categories).map(([category, count]) => ({
        name: category,
        count: count,
    }))
            setListItems(flatCategories)
}
    }, [backendFilters]);

  return (
    <LinkBox
        as="section"
      
       
   
        mb={2}
        ml={1}
        mt={1}
        bg={sectionBg}
        fontSize="sm"
        transition="all 0.2s ease-in-out"
      
        borderColor={dividerColor}
        wrap="wrap"
        color={"var(--crt-4)"}
    >
     
        
        {listItems.map((item, index) => (
            // Simplified structure: only show the main category link and its count.
            <Box key={item.name} pt={0} pb={1} pl={1} w="full" mb="0" display="flex" justifyContent="space-between">
                <Link 
                    color={selectedCategory === item.name ? "var(--cr-red-logo)" : "muted"} 
                    display="flex" 
                    onClick={() => {
                        // Pass the category name to the filter handler
                        handleFilterChange("categories", item.name);
                        // Update the local state for styling
                        setSelectedCategory(item.name);
                        // Ensure subcategory filter is cleared if it was used before
                        handleFilterChange("subcategory", null); 
                    }}
                >
                    <FaMinus size={10} style={{ marginRight: '0.4rem' }} />
                    {item.name}
                </Link>
            </Box>
        ))}
        
    </LinkBox>

    );
}